module.exports = __webpack_public_path__ + "static/media/s2.211b151f.png";